import api from '../index';

export const getActivityLogsApi = (repairOrderId) => {
  return api({
    method: 'get',
    url: `repairOrder/get-repair-order-logs-by-id/${repairOrderId}`,
  });
};
